import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function BearingsContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="bearing" />
    </SceneMenuContent>
  );
}
